/** @jsx jsx */
import { SyntheticEvent } from 'react';
import { memoize } from 'lodash';
import { SearchableSelectField } from '@zapier/common-components';
import { jsx } from '@emotion/core';
import { weightedSearch } from '@zapier/common-utils';
import usStates, { USState } from './usStates';

const stateSearch = memoize(weightedSearch);

type StateSelectProps = {
  /** Show Error Styling */
  hasError?: boolean;
  /** Id of label element */
  labelId?: string;
  /** Handle item change */
  onChange: (event: SyntheticEvent<HTMLInputElement> | string) => void;
  /** Initial value */
  value?: string;
};

const StateSelect: React.FC<StateSelectProps> = ({
  hasError,
  labelId,
  onChange,
  value,
}) => {
  const initialValue = value ? usStates.find(c => c.code === value) : null;
  return (
    <SearchableSelectField
      autoComplete="shipping address-level1"
      filterItems={stateSearch}
      getKeyForItem={(item: USState) => item.code}
      getLabelForItem={(item: USState) => item.name}
      hasError={hasError}
      initialSelectedItem={initialValue}
      items={usStates}
      labelId={labelId}
      menuAriaLabel="address states"
      name="addressState"
      onChange={onChange}
      placeholder="Select a state..."
    />
  );
};

export default StateSelect;
